import { render, staticRenderFns } from "./RemessasBancarias.vue?vue&type=template&id=a345ee1c&scoped=true&"
import script from "./remessasBancarias.js?vue&type=script&lang=js&"
export * from "./remessasBancarias.js?vue&type=script&lang=js&"
import style0 from "./RemessasBancarias.vue?vue&type=style&index=0&id=a345ee1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a345ee1c",
  null
  
)

export default component.exports